export enum ImageActionType {
  /*
   | ---------------------------------------------------------------------------
   |  Draft Creation Actions
   | ---------------------------------------------------------------------------
   |
   | These actions are for creating a new image draft. New image drafts may be
   | based on an existing image or may upload a new (empty) image.
   |
   */
  UploadError = 'image/UPLOAD_ERROR',
  UploadRequest = 'image/UPLOAD_REQUEST',
  UploadSuccess = 'image/UPLOAD_SUCCESS',

  /*
   | ---------------------------------------------------------------------------
   |  Draft Load Actions
   | ---------------------------------------------------------------------------
   |
   | These actions are for loading existing image drafts into state from the
   | server.
   |
   */
  Load = 'image/LOAD',
  LoadError = 'image/LOAD_ERROR',
  LoadRequest = 'image/LOAD_REQUEST',
  LoadSuccess = 'image/LOAD_SUCCESS',

  /*
   | ---------------------------------------------------------------------------
   |  Draft Setter Actions
   | ---------------------------------------------------------------------------
   |
   | These actions work with the value of
   |
   */
  SetUploadProgress = 'image/SET_UPLOAD_PROGRESS',
}
